import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import logo from './assets/auisoft.png';
import './App.css';
import Home from './views/Home';
import TreeLayout from './samples/TreeLayout';
import TableLayout from './samples/TableLayout';
import TableMergeLayout from './samples/TableMergeLayout';

// 샘플 메뉴 리스트
const mainMenuList = [
	{ path: '/TreeLayout', name: 'TreeLayout', text: '피벗 출력 방식 - 트리(기본값)', element: <TreeLayout /> },
	{ path: '/TableLayout', name: 'TableLayout', text: '피벗 출력 방식 - 테이블', element: <TableLayout /> },
	{ path: '/TableMergeLayout', name: 'TableMergeLayout', text: '피벗 출력 방식 - 테이블 셀병합', element: <TableMergeLayout /> },
];

function App() {
	const [isNavOpen, setIsNavOpen] = useState(window.innerWidth >= 1300 ? true : false);

	const handleKnobClick = () => {
		setIsNavOpen(!isNavOpen);
	};

	const handleLinkClick = () => {
		if (window.innerWidth < 1300) {
			setIsNavOpen(false);
		}
	};

	useEffect(() => {
		const handleResize = (e) => {
			//console.log('window 리사이징');
			if (window.innerWidth >= 1300) {
				setIsNavOpen(true);
			} else {
				setIsNavOpen(false);
			}
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<BrowserRouter basename={process.env.PUBLIC_URL}>
			<div className="app">
				<div className="header">
					<div className="logo-bar">
						<button className="knob-btn" onClick={handleKnobClick}>
							<span className="knob-bar"></span>
							<span className="knob-bar"></span>
							<span className="knob-bar"></span>
						</button>
						<img id="logo" src={logo} alt="AUISoft" />
						<span className="title">AUIPivot 2.5 DEMO for React.js</span>
					</div>
					<div className="header-buttons">
						<a href="https://www.auisoft.net/dcenter.html" className="btn btn-primary">
							DOWNLOAD FREE TRIAL
						</a>
						<a href="https://www.auisoft.net/price.html" className="btn btn-primary">
							PRICING &amp; LICENSE
						</a>
					</div>
				</div>
				<div className="nav" style={isNavOpen ? { transform: 'translateX(0px)' } : { transform: 'translateX(-300px)' }}>
					<h3 className="force-text-center">AUIPivot for React</h3>
					<ul className="nav-menu">
						<li>
							<NavLink to="/" onClick={handleLinkClick}>
								<span className="nav-item" style={{ fontWeight: 500 }}>
									HOME
								</span>
							</NavLink>
						</li>
						{mainMenuList.map((item, index) => (
							<li key={index}>
								<NavLink to={item.path} onClick={handleLinkClick} className={({ isActive }) => (isActive ? 'nav-item-active' : '')}>
									<span className="nav-item">
										{index + 1}. {item.text}
									</span>
								</NavLink>
							</li>
						))}
					</ul>
					<div className="nav-border"></div>
				</div>
				<div className="container">
					<div className="view-content">
						<Routes>
							<Route className="page" exact path="/" element={<Home />} />
							{mainMenuList.map(({ name, path, element }) => (
								<Route key={name} className="page" exact path={path} element={element} />
							))}
						</Routes>
					</div>
				</div>
				<div className="footer">
					<span>Copyright © AUISoft Co., Ltd.</span>
				</div>
			</div>
		</BrowserRouter>
	);
}

export default App;
